var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container elevation-1 d-flex justify-center align-center",style:({ 
    backgroundColor: _vm.bgColor, 
    width: _vm.size + 'px', 
    height: _vm.size + 'px', 
    borderRadius: _vm.borderRadius + 'px',
    color: _vm.iconColor
  })},[(!_vm.isImage)?_c('v-icon',{style:({ color: _vm.iconColor })},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_c('img',{attrs:{"src":_vm.icon,"height":_vm.iconSize,"width":_vm.iconSize,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }